// extracted by css-extract-rspack-plugin
export default {"bannerWrapper":"CopilotAccessRequestSuccessBanner-module__bannerWrapper__oLuTXPG"};